const filters = {
  btnFilters: 'Filter',
  titleDropdown: 'Schnellfilter',

  filterDate: {
    today: 'Heute',
    tomorrow: 'Morgen',
    yesterday: 'Gestern',
    lastWeek: 'Letzte Woche',
    lastMonth: 'Letzter Monat',
    customRange: 'Benutzerdefinierter Bereich',
    overLimit: 'Bitte wählen Sie einen Zeitraum von {{limit}} Tagen oder weniger',
    
    fromTime: 'Von Zeit',
    toTime: 'Zur Zeit',
  },
};

export default filters;
